const ENDPOINTS = {
  CHANGE_USER_PASSWORD: '/changeUserPassword',
  ADD_POINTS: '/addPoints',
  UPDATE_POINTS: '/updatePoints'
}

export default ENDPOINTS
export { ENDPOINTS }
